<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <n-divide class="table-tools">
      <div></div>
      <n-link v-if="edit.records" :to="createRecordLink()"><n-button>Создать запись</n-button></n-link>
    </n-divide>

    <n-table :columns="columns" :data="data">
      <template #headerRow>
        <tr class="header">
          <td>Дата выполнения работ, смена</td>
          <td>Описание производимых работ, наименование устанавливаемых конструкций, их марка, результаты осмотра конструкций</td>
          <td>Место установки и номера монтажных схем</td>
          <td>Номера технических паспортов на конструкции</td>
          <td>Атмосферные условия (температура окружающего воздуха, осадки, скорость ветра)</td>
          <td>Фамилия, инициалы исполнителя (бригадира)</td>
          <td>Подпись исполнителя (бригадира)</td>
          <td>Замечания и предложения по монтажу конструкций руководителей монтажной организации, авторского надзора, технического надзора заказчика</td>
          <td>Подпись мастера (производителя работ), разрешившего производство работ и принявшего работу. Подпись лиц осуществляющих авторский надзор</td>
          <td></td>
        </tr>
      </template>
      <template #date="{item}">
        {{ $app.date.format(item.date) }} {{ item.shift }}
      </template>
      <template #recordsSign="{item}">
        <c-journal-sign :sign="getSign(item, 'records')" />
      </template>
      <template #masterSign="{item}">
        <c-journal-sign :sign="getSign(item, 'master')" />
      </template>
      <template #tools="{item}">
        <n-link :to="showRecordLink(item.id)"><n-button icon="eye" /></n-link>
      </template>
    </n-table>

    <page-record-create v-if="newRecord" :project="project" :journal="journal" @reload="load" @close="$router.push(createRecordLink(false))" />
    <modal-record v-if="showRecord" :project="project" :journal="journal" @reload="load" @close="$router.push(showRecordLink(false))" />
  </div>
</template>

<script>
import PageRecordCreate from './Create'
import ModalRecord from './record/Index'
import utils from 'utils'
import CJournalSign from 'components/journal/Sign'

export default {
  name: 'MainChapter4',
  components: { ModalRecord, PageRecordCreate, CJournalSign, },
  props: [ 'project', 'journal', ],
  data: () => ({
    utils,
    data: [
    ],
  }),
  computed: {
    newRecord() {
      return this.$route.query['new'] !== undefined
    },
    showRecord() {
      return this.$route.query['show'] !== undefined
    },
    edit() {
      return {
        records: $app.auth.can('journals_installation_records', this.project.id),
      }
    },
    columns() {
      return [
        { name: 'date', title: '', },
        { name: 'description', title: '', },
        { name: 'place', title: '', },
        { name: 'number', title: '', },
        { name: 'weather', title: '', },
        { name: 'recordsSign', title: '', },
        { name: 'recordsSign', title: '', },
        { name: 'remark', title: '', },
        { name: 'masterSign', title: '', },
        { name: 'tools', title: '', },
      ]
    },
  },
  watch: {
    project() {
      this.load()
    },
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journals.records.get(this.project.id, 'spec9')
        .query({
          'with[author][with][participation]': null,
          'with[signs][with][author]': null,
          projectId: this.project.id,
        })
        .then((response) => {
          this.data = response.data.content
        }).finally(() => {
          this.$var('load', false)
        })
    },
    getUser(item, name) {
      if (!item[name]) {
        return ''
      }
      return item[name]?.participation?.position + ', ' + item[name]?.fullName
    },
    createRecordLink(open = true) {
      return { query: { ...this.$route.query, 'new': open ? null : undefined, }, }
    },
    showRecordLink(open) {
      return { query: { ...this.$route.query, 'show': open || undefined, }, }
    },
    getSign(item, name) {
      return $n.find(item.signs, [ 'name', name, ])
    },
  },
}
</script>

<style lang="scss" scoped>
.main-chapter1 {

}
</style>
